import _ from 'underscore';
import { ProjectionGridBaseColumn } from '@bingads-webui/projection-grid-base-column';
import { formatDecimal, getIncreaseSymbol } from '@bingads-webui-campaign/recommendation-core';
import template from './estimate-search-column.pug';

export class EstimateSearchColumn extends ProjectionGridBaseColumn {
  constructor({
    i18n, recommendationType, isOptimizationScoreOn,
  }) {
    const title = i18n.getString('Details_View_Estimate_Search') || 'Weekly est. searches';
    super({
      name: 'EstimateSearch',
      property: 'Opportunities/EstimatedIncreaseInSearches',
      title,
      bodyClasses: ['grid-column-estimateSearch', isOptimizationScoreOn ? 'with-optimization-score' : ''],
      colClasses: ['col-numberEst'],
      sortable: true,
      helpId: 'pop_BA_Recommendations_DSA_WeeklyEstSQ',
      type: 'number',
      helpAriaLabel: i18n.getString('Click to learn more about {{item}}', { item: title }),
    });
    this.i18n = i18n;
    this.recommendationType = recommendationType;
    this.isOptimizationScoreOn = isOptimizationScoreOn;
  }

  template({
    value: {
      EstimatedIncreaseInSearches,
    },
  }) {
    return template({
      deltaVal: formatDecimal(EstimatedIncreaseInSearches, this.i18n),
      increaseSymbol: getIncreaseSymbol(EstimatedIncreaseInSearches),
      notAvailable: EstimatedIncreaseInSearches === 0,
      isOptimizationScoreOn: this.isOptimizationScoreOn,
    });
  }

  get property() {
    return {
      get: item => _.first(item.Opportunities),
    };
  }
}
